// src/App.tsx

import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useTranslation } from './i18n';
import { GlobalStyle } from './styles/GlobalStyles';
import LandingPage from './pages/LandingPage';
import MainPage from './pages/MainPage';
import PatientLoginPage from './pages/PatientLoginPage';
import PatientAssistantPage from './pages/PatientAssistantPage';
import InstitutionManagementPage from './pages/InstitutionManagementPage';
import GlobalLanguageSwitcher from './components/GlobalLanguageSwitcher';

// 언어 스위처를 조건부로 렌더링하는 컴포넌트
const ConditionalLanguageSwitcher: React.FC = () => {
  const location = useLocation();
  
  // PatientAssistantPage 경로에서는 언어 스위처를 숨김
  const shouldHideLanguageSwitcher = location.pathname.startsWith('/patient/') && 
    location.pathname.split('/').length >= 4; // /patient/:surgeryName/:patientName 형태
  
  if (shouldHideLanguageSwitcher) {
    return null;
  }
  
  return <GlobalLanguageSwitcher />;
};

function App() {
  const { t } = useTranslation();
  return (
    <>
      <GlobalStyle />
      <Router>
        <ConditionalLanguageSwitcher />
        <Routes>
          {/* 🔥 새로 추가: 랜딩 페이지 */}
          <Route path="/" element={<LandingPage />} />
          
          {/* 🔥 변경: 관리자 메인 페이지 */}
          <Route path="/main" element={<MainPage />} />
          
          {/* 환자 로그인 페이지 */}
          <Route path="/patient" element={<PatientLoginPage />} />
          
          {/* 환자 상담 페이지 - 기관번호, 환자번호, 의사 ID 선택적 */}
          <Route 
            path="/patient/:surgeryName/:patientName/:doctorId?" 
            element={<PatientAssistantPage />} 
          />

          {/* 기관 관리 페이지 */}
          <Route
            path="/institution-management" 
            element={<InstitutionManagementPage />}
          />

          <Route
            path="*" 
            element={<div role="alert" aria-live="polite">{t('common.notFound')}</div>} // 404 페이지
          />
        </Routes>
      </Router>
    </>
  );
}

export default App;